// extracted by mini-css-extract-plugin
export default {"panel":"LJjHIQzNJTOUrL3Vfati","formItem":"HDiqHcoWzRebnsXylF86","select":"E7DIWPYo6E7IKvIRLw_b","input":"zkVxlYKuDvRIaM0XYWOd"};